import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  id: PropTypes.string,
};

const TripleColumnGrid = ({
  color = '#B5BCBD',
  size = 18,
  id = 'triple-column-grid',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M4.637 6.218c.513 0 .928.415.928.927v3.71a.927.927 0 0 1-.928.927H.927A.927.927 0 0 1 0 10.855v-3.71c0-.512.415-.927.927-.927h3.71zm6.218 0c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.927-.927v-3.71c0-.512.415-.927.927-.927h3.71zM4.637 0c.513 0 .928.415.928.927v3.71a.927.927 0 0 1-.928.928H.927A.927.927 0 0 1 0 4.637V.927C0 .415.415 0 .927 0h3.71zm6.218 0c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.928h-3.71a.927.927 0 0 1-.927-.928V.927c0-.512.415-.927.927-.927h3.71zm6.218 6.218c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.928-.927v-3.71c0-.512.415-.927.928-.927h3.71zM4.637 12.435c.513 0 .928.415.928.928v3.71a.927.927 0 0 1-.928.927H.927A.927.927 0 0 1 0 17.073v-3.71c0-.513.415-.928.927-.928h3.71zm6.218 0c.512 0 .927.415.927.928v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.927-.927v-3.71c0-.513.415-.928.927-.928h3.71zm6.218 0c.512 0 .927.415.927.928v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.928-.927v-3.71c0-.513.415-.928.928-.928h3.71zm0-12.435c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.928h-3.71a.927.927 0 0 1-.928-.928V.927c0-.512.415-.927.928-.927h3.71z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        d="M4.637 6.218c.513 0 .928.415.928.927v3.71a.927.927 0 0 1-.928.927H.927A.927.927 0 0 1 0 10.855v-3.71c0-.512.415-.927.927-.927h3.71zm6.218 0c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.927-.927v-3.71c0-.512.415-.927.927-.927h3.71zM4.637 0c.513 0 .928.415.928.927v3.71a.927.927 0 0 1-.928.928H.927A.927.927 0 0 1 0 4.637V.927C0 .415.415 0 .927 0h3.71zm6.218 0c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.928h-3.71a.927.927 0 0 1-.927-.928V.927c0-.512.415-.927.927-.927h3.71zm6.218 6.218c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.928-.927v-3.71c0-.512.415-.927.928-.927h3.71zM4.637 12.435c.513 0 .928.415.928.928v3.71a.927.927 0 0 1-.928.927H.927A.927.927 0 0 1 0 17.073v-3.71c0-.513.415-.928.927-.928h3.71zm6.218 0c.512 0 .927.415.927.928v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.927-.927v-3.71c0-.513.415-.928.927-.928h3.71zm6.218 0c.512 0 .927.415.927.928v3.71a.927.927 0 0 1-.927.927h-3.71a.927.927 0 0 1-.928-.927v-3.71c0-.513.415-.928.928-.928h3.71zm0-12.435c.512 0 .927.415.927.927v3.71a.927.927 0 0 1-.927.928h-3.71a.927.927 0 0 1-.928-.928V.927c0-.512.415-.927.928-.927h3.71z"
        stroke={color}
        strokeWidth="2"
        mask={`url(#${id}-b)`}
      />
    </g>
  </svg>
);

TripleColumnGrid.propTypes = propTypes;

export default TripleColumnGrid;
